<template>
  <v-row dense>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        outlined
        class="pa-3"
      >
        <div class="text-overline grey--text text--darken-1">
          Total rows
        </div>
        <div class="text-h5 font-weight-bold">
          {{ totalDisplay }}
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        outlined
        class="pa-3"
      >
        <div class="text-overline grey--text text--darken-1">
          Matched
        </div>
        <div class="text-h5 font-weight-bold success--text">
          {{ matchedDisplay }}
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        outlined
        class="pa-3"
      >
        <div class="text-overline grey--text text--darken-1">
          BCEL unmatched
        </div>
        <div class="text-h5 font-weight-bold amber--text text--darken-3">
          {{ formatCount(bcelUnmatched) }}
        </div>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
    >
      <v-card
        outlined
        class="pa-3"
      >
        <div class="text-overline grey--text text--darken-1">
          LDB unmatched
        </div>
        <div class="text-h5 font-weight-bold amber--text text--darken-3">
          {{ formatCount(ldbUnmatched) }}
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { getRecords } from '@/store/apis/bulkReconciliation';

export default {
  name: 'BulkSummaryStrip',
  props: {
    uuid: {
      type: String,
      required: true,
    },
    batch: {
      type: Object,
      required: true,
    },
    refetchKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      bcelUnmatched: null,
      ldbUnmatched: null,
    };
  },
  computed: {
    totalDisplay() {
      return this.formatCount(this.batch.total_rows);
    },
    matchedDisplay() {
      return this.formatCount(this.batch.matched_rows);
    },
  },
  watch: {
    refetchKey: {
      immediate: true,
      handler() { this.refresh(); },
    },
  },
  methods: {
    formatCount(n) {
      if (n === null || n === undefined) return '—';
      return Number(n).toLocaleString();
    },
    async refresh() {
      const params = {
        match_status: 'unmatched',
        resolution_status: 'pending',
        per_page: 1,
      };
      try {
        const [bcel, ldb] = await Promise.all([
          getRecords(this.uuid, { ...params, bank: 'BCEL' }),
          getRecords(this.uuid, { ...params, bank: 'LDB' }),
        ]);
        this.bcelUnmatched = bcel.total ?? bcel.meta?.total ?? 0;
        this.ldbUnmatched = ldb.total ?? ldb.meta?.total ?? 0;
      } catch (err) {
        // Counts are non-critical; fall back to em-dash and log.
        // The orchestrator's polling/error path surfaces real issues.
        // eslint-disable-next-line no-console
        console.warn('BulkSummaryStrip count refresh failed', err);
      }
    },
  },
};
</script>
